<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <div class="vx-row">
            <div class="vx-col w-full lg:w-1/5 mb-base">
                <vx-card class="p-2">
                    <div class="text-center">
                        <h4>{{ patientUsername }}</h4>
                        <p class="text-grey">{{ patientAge }}, {{ patientGender }}</p>
                    </div>
                    <vs-avatar class="mx-auto my-6 block" size="80px" />
                    <div class="flex justify-between text-center">
                        <span>
                            <p class="font-semibold">{{ medicalRoomNm }}({{ medicalRoomNumberNm }})</p>
                            <small class="text-grey">병동(호실)</small>
                        </span>
                        <span>
                            <p class="font-semibold">{{ medicalName }}</p>
                            <small class="text-grey">본 병원</small>
                        </span>
                        <span>
                            <p class="font-semibold">{{ sickNess }}</p>
                            <small class="text-grey">병명</small>
                        </span>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="my-6">
                        <h5 class="mb-2">치료플랜</h5>
                        <p class="text-grey">{{ plan }}</p>
                    </div>
                    <div class="my-6">
                        <h5 class="mb-2">메모</h5>
                        <vs-textarea placeholder="자유롭게 작성 후 저장버튼 클릭." height="200px" v-model="memo" />
                    </div>

                    <vs-button type="gradient" class="w-full mt-6" color="#7367F0" gradient-color-secondary="#CE9FFC" @click="patientMemoSave">저장</vs-button>
                </vx-card>
            </div>
            <div class="vx-col w-full lg:w-4/5 mb-base">
                <vx-card title="스케줄 관리(리스트)">
                    <div class="vx-row">
                        <div class="vx-col w-full xl:w-1/1 mb-base">
                            <vs-button type="gradient" class=" mt-6" color="#7367F0" gradient-color-secondary="#CE9FFC" @click="$router.push('/patientSchedule/scheduleCalendar/' + patient_member_uid)"
                                >달력 스케줄 보기</vs-button
                            >
                            <div class="text-right">
                                <a :href="'/api/patientCalendar/calendarExcel/' + patient_member_uid + '?year_month=' + now_date" download="download"
                                    ><vs-button size="small">엑셀다운로드</vs-button></a
                                >
                            </div>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full xl:w-1/1 mb-base text-center">
                            <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="prevMonth"></vs-button> <span class="ml-5 mr-5">{{ nowDate }}</span
                            ><vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="nextMonth"></vs-button>
                        </div>
                    </div>
                    <div class="tb_wrap" style="width:100%;overflow:auto;">
                        <div class="tb_box">
                            <table style="width:100%;min-width:1200px;" class="border-collapse calendar" id="schedule">
                                <thead>
                                    <tr class="fixed_top">
                                        <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="min-width:100px;">시간 / 일</th>
                                        <th
                                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                            :style="item.substring(6, 8) == now_day ? 'border:5px solid red !important;' : ''"
                                            v-for="(item, index) in date_list"
                                            :key="index"
                                            :id="item"
                                        >
                                            {{ dayReturn(item) }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in calendar_data" :key="index">
                                        <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">
                                            {{ item.CODE_TIME.substring(0, 2) }}:{{ item.CODE_TIME.substring(2, 4) }}
                                        </th>
                                        <td
                                            class="border border-solid d-theme-border-grey-light"
                                            style="min-width:180px;height:100px;vertical-align:top;"
                                            v-for="(schedule_item, schedule_index) in item.YMD.split(',')"
                                            :key="schedule_index"
                                        >
                                            <span class="font-size:5px !important;">{{ item.CODE_TIME.substring(0, 2) }}:{{ item.CODE_TIME.substring(2, 4) }}</span>
                                            <vs-chip
                                                color="danger"
                                                class="w-full"
                                                v-if="scheduleisShow(index, schedule_index)"
                                                closable
                                                @click="calendarTdDelete(schedule_item, index, schedule_index)"
                                            >
                                                {{ scheduleisShowText(index, schedule_index) }}
                                            </vs-chip>
                                            <!-- <template v-for="(item_data, item_index) in gridReturn(index, schedule_index)">
                                            <vs-chip color="danger" class="w-full" :key="item_index">
                                                {{ item_data.medical_nm }}
                                            </vs-chip>
                                        </template> -->
                                            <div class="days_right">
                                                <vs-button
                                                    radius
                                                    color="dark"
                                                    type="line"
                                                    icon-pack="feather"
                                                    icon="icon-plus"
                                                    v-if="!scheduleisShow(index, schedule_index)"
                                                    @click="calendarTdClick(schedule_item, index, 0)"
                                                ></vs-button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>

        <vs-popup title="스케줄 등록" :active.sync="calendarWritePopup">
            <form>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-input class="w-full" name="select_date" v-model="select_date" label="선택날짜" placeholder="" :disabled="true" />
                        <!-- <datepicker name="uniquename"></datepicker> -->
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-select autocompleteclass="w-auto" v-model="medical_cd" label="치료실 / 원장실 / 기타" placeholder="스케줄 옵션">
                            <vs-select-item v-for="(item, index) in medical_code_list" :key="index" :value="item.MEDICAL_CD" :text="item.MEDICAL_NM" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <div class="vx-col w-full">
                            <vs-select autocompleteclass="w-auto" v-model="select_time" label="시간" placeholder="시간 선택" :disabled="true">
                                <vs-select-item v-for="(item, index) in time_list" :key="index" :value="item.CODE_TIME" :text="item.TIME_NAME" />
                            </vs-select>
                        </div>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="calendarSave">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="popupClose">닫기</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import Datepicker from 'vuejs-datepicker';

export default {
    components: {
        Datepicker,
    },
    data() {
        return {
            calendar_temp: [],
            calendar_date: [],
            now_date: '',
            prev_date: '',
            next_date: '',
            today: null,
            calendar_data: [],

            medical_code_list: [],
            time_list: [],
            calendarWritePopup: false,
            date_list: [],
            patient_member_uid: '',
            select_date: '',
            medical_cd: '',
            select_time: '',
            row_index: -1,
            cell_index: -1,
            schedule_seq: -1,
            msg: '',
            patientUsername: '',
            patientAge: '',
            patientGender: '',
            medicalRoomNm: '',
            medicalRoomNumberNm: '',
            medicalName: '',
            sickNess: '',
            plan: '',
            memo: '',
            now_day: '',
            width: window.innerWidth,
        };
    },

    computed: {
        nowDate() {
            return this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월';
        },
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        async init(date) {
            this.now_day = dateClass.nowday();
            if (date == '') {
                this.now_date = dateClass.dateYYYYMM();
            } else {
                this.now_date = date;
            }
            this.prev_date = dateClass.prevYYYYMM(this.now_date);
            this.next_date = dateClass.nextYYYYMM(this.now_date);
            const jsonData = {
                year_month: this.now_date,
            };
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            const { data } = await axiosClass.get('/api/patientCalendar/calendarList/' + this.patient_member_uid, jsonData, true);
            console.log(data);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);
            this.date_list = data.list[0].YMD.split(',');
            this.calendar_data = data.list;
            this.patientUsername = data.patientData.PATIENT_USERNAME;
            this.patientAge = data.patientData.PATIENT_AGE;
            this.patientGender = data.patientData.PATIENT_GENDER_CONVERT;
            this.medicalRoomNm = data.patientData.MEDICAL_ROOM_NM;
            this.medicalRoomNumberNm = data.patientData.MEDICAL_ROOM_NUMBER_NM;
            this.medicalName = data.patientData.MEDICAL_NAME;
            this.sickNess = data.patientData.SICKNESS;
            this.plan = data.patientData.PLAN;
            this.memo = data.patientData.MEMO;
            // console.log(this.calendar_data);
            setTimeout(function() {
                location.href = '#' + dateClass.dateYYYYMMDD();
                // location.href = '#' + dateClass.nowhour() + ':00';
            }, 500);
        },
        async calendarPopup() {
            this.calendarWritePopup = true;
        },
        async calendarTdClick(date, row_index, cell_index) {
            this.calendarWritePopup = true;

            this.select_date = '';
            this.row_index = -1;
            this.cell_index = -1;
            this.schedule_seq = -1;

            this.medical_cd = '';
            this.select_time = this.calendar_data[row_index].CODE_TIME;

            const temp = date.split('///');
            const day = temp[0];
            this.select_date = date;
            this.row_index = row_index;
            this.cell_index = cell_index;

            const { data } = await axiosClass.get('/api/patientCalendar/calendarSelect/' + this.patient_member_uid + '/' + this.select_date, {}, true);
            console.log(data);

            this.medical_code_list = data.medical_code_list;
            this.time_list = data.time_list;
        },

        async calendarTdDelete(date, row_index, cell_index) {
            const schedule_temp_array = this.calendar_data[row_index].SCHEDULE_SEQ.split(',');
            this.select_date = date;
            this.row_index = row_index;
            this.cell_index = cell_index;
            this.schedule_seq = schedule_temp_array[cell_index];

            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '해당 스케줄을 정말로 삭제하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: this.calendarTdDeleteSubmit,
            });
        },

        async calendarTdDeleteSubmit() {
            const { data } = await axiosClass.delete('/api/patientCalendar/calendarSelect/' + this.patient_member_uid + '/' + this.select_date + '/' + this.schedule_seq, {}, true);
            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 삭제되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
            this.init(this.now_date);
        },
        popupClose() {
            this.calendarWritePopup = false;
        },

        returnScheduleArr(item) {
            // console.log(item);
            if (item == '') {
                return '';
            } else {
                let temp = item.split('///');
                // console.log(temp);
                let arr = temp[1].split(',');
                return arr;
            }
        },

        returnValueClass(item) {
            let temp = item.split('|');
            // console.log(temp[0].substring(0, 2));
            if (temp[0].substring(0, 2) == '01') {
                // console.log('success');
                return 'success';
            } else {
                return 'warning';
            }
        },

        returnValueName(item) {
            if (item == '') {
                return '';
            } else {
                // console.log(item);
                let temp = item.split('|');
                return '[' + temp[1].substring(0, 2) + ':' + temp[1].substring(2, 4) + '] ' + temp[2];
            }
        },

        calendarDataRemove() {
            this.calendarWritePopup = false;
        },

        async calendarSave() {
            if (this.medical_cd == '') {
                this.$vs.notify({
                    title: 'Error',
                    text: '스케줄 등록 장소를 선택해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }
            const jsonData = {
                medical_cd: this.medical_cd,
                select_time: this.select_time,
            };
            const { data } = await axiosClass.post('/api/patientCalendar/calendarSelect/' + this.patient_member_uid + '/' + this.select_date, jsonData, true);
            switch (data.err_code) {
                case '000':
                    this.calendarWritePopup = false;
                    this.$vs.notify({
                        title: 'Success',
                        text: '정상적으로 등록되었습니다.',
                        color: 'success',
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-check',
                    });
                    this.init(this.now_date);
                    break;
                default:
                    this.$vs.notify({
                        title: 'Error',
                        text: data.err_msg,
                        color: 'danger',
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-check',
                    });
                    break;
            }
        },
        prevMonth() {
            this.init(this.prev_date);
        },
        nextMonth() {
            this.init(this.next_date);
        },
        dayReturn(item) {
            return parseInt(item.substring(4, 6)) + '월 / ' + parseInt(item.substring(6, 8)) + '일';
        },

        scheduleisShow(calendar_index, schedule_index) {
            const temp = this.calendar_data[calendar_index].SCHEDULE_SEQ.split(',');
            // console.log(temp);
            if (temp[schedule_index] == '') {
                return false;
            } else {
                return true;
            }
        },
        scheduleisShowText(calendar_index, schedule_index) {
            const temp = this.calendar_data[calendar_index].MEDICAL_NM.split(',');
            let text =
                this.dayReturn(this.date_list[schedule_index]) +
                '[' +
                this.calendar_data[calendar_index].CODE_TIME.substr(0, 2) +
                ':' +
                this.calendar_data[calendar_index].CODE_TIME.substr(2, 2) +
                ']-' +
                temp[schedule_index];
            return text;
        },
        //환자 메모 저장
        async patientMemoSave() {
            this.memo;
            const jsonData = {
                memo: this.memo,
            };
            console.log(this.patient_member_uid);

            const { data } = await axiosClass.post('/api/patientCalendar/patientMemoSave/' + this.patient_member_uid, jsonData, true);

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 저장 되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.patient_member_uid = this.$route.params.uid;
        this.init('');
        // this.calendar('');
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style>
.day {
    padding: 10px;
    display: flex;
    align-items: center;
}

.days_left {
    width: 50%;
    flex-direction: row;
    justify-content: center;
    font-size: 1.4rem;
    padding-left: 5px;
}

.days_right {
    width: 100%;
    text-align: right;
    flex-direction: row;
    padding-right: 5px;
}

.sun {
    color: red;
}
.sat {
    color: blue;
}

.dayContents {
    padding: 10px;
    overflow: auto;
    min-height: 100px;
}

.calendar tr td {
    vertical-align: top;
}

.calendar tr td:hover {
    background-color: rgba(241, 241, 241, 0.2);
    cursor: pointer;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 1.1rem;
}

.calendar tbody tr td {
    padding: 10px;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 0.9rem;
}

.activeMenu {
    border-color: #015666;
}

.display-time {
    padding: 0.7rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
